"use strict";
// Blend Mode data type parser
// Handles parsing of CSS blend mode values according to MDN specification
// https://developer.mozilla.org/en-US/docs/Web/CSS/blend-mode
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = parse;
exports.toCSSValue = toCSSValue;
const shared_utils_1 = require('../utils/shared-utils.cjs');
const css_variable_1 = require('./css-variable.cjs');
const types_1 = require('../types.cjs');
// Use centralized blend mode keywords from types.ts
/**
 * Parses a CSS blend mode value into structured components
 * @param input - The CSS blend mode string
 * @returns Parsed blend mode object or null if invalid
 */
function parse(input) {
    if (!input || typeof input !== 'string') {
        return null;
    }
    const trimmed = input.trim();
    if (trimmed === '') {
        return null;
    }
    // Check for CSS variables - parse them if valid
    if ((0, shared_utils_1.isCssVariable)(trimmed)) {
        return (0, css_variable_1.parse)(trimmed);
    }
    const lowerValue = trimmed.toLowerCase();
    // Check for global keywords first
    if ((0, shared_utils_1.isGlobalKeyword)(lowerValue)) {
        return {
            type: 'keyword',
            keyword: lowerValue
        };
    }
    // Check for blend mode values
    if (types_1.BLEND_MODE_KEYWORDS.includes(lowerValue)) {
        return {
            type: 'keyword',
            keyword: lowerValue
        };
    }
    return null;
}
/**
 * Converts a parsed blend mode back to a CSS value string
 * @param parsed - The parsed blend mode object
 * @returns CSS value string or null if invalid
 */
function toCSSValue(parsed) {
    if (!parsed) {
        return null;
    }
    // Handle CSS variables
    if ('CSSvariable' in parsed) {
        return (0, css_variable_1.toCSSValue)(parsed);
    }
    // Handle keyword values (both global and blend-mode specific)
    if ('keyword' in parsed) {
        return parsed.keyword;
    }
    return null;
}
